import axios from 'axios';

export default axios.create({
  baseURL: 'https://saddam-chat-app-server.herokuapp.com',
});
